import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "statistics",
  "use": "statistics-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"statistics\"><defs><style></style></defs><path d=\"M896 832H128V224a32 32 0 00-64 0v640a32 32 0 0032 32h800a32 32 0 100-64z\" /><path d=\"M247.008 640c7.424 0 14.88-2.56 20.96-7.808l179.744-155.84 174.56 155.52a31.968 31.968 0 0044.704-2.08l250.432-269.216a32 32 0 10-46.88-43.616L641.44 563.264l-172.128-153.44a32.064 32.064 0 00-42.272-.288l-200.992 174.24A32 32 0 00247.008 640z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol